import { UGC_GET_REQUEST,UGC_RIGHTS_ACTION } from "./api"
import HttpClient from "./http-client"

export const getRightsDetails = (id) => {
    return new HttpClient().get(`${UGC_GET_REQUEST}/${id}`)
}

export const ugcAction = (data) => {
    return new HttpClient().post(UGC_RIGHTS_ACTION, data)
}